import type { AdminCatalogEntry } from "./adminNavigationCatalog";

export const adminIdentityNavigation: readonly AdminCatalogEntry[] = [
  { group: "tenants", path: "/admin/tenants", titleKey: "AdminUsers.tenants", icon: "ApartmentOutlined" },
  { group: "tenants", path: "/admin/users", titleKey: "AdminUsers.title", icon: "UserOutlined" },
];
